/* eslint-disable @typescript-eslint/naming-convention */
export enum WeekDay {
    Saturday = 'Saturday',
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
}
